import { render, staticRenderFns } from "./stats-page.vue?vue&type=template&id=d233dfe4"
import script from "./stats-page.vue?vue&type=script&lang=ts"
export * from "./stats-page.vue?vue&type=script&lang=ts"
import style0 from "./stats-page.vue?vue&type=style&index=0&id=d233dfe4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VIcon,VRow})
